import { create } from 'zustand';

import { type ChatComposerSlice, createChatComposerSlice } from './slices/createChatComposerSlice';

export type ChatComposerState = ChatComposerSlice;

export const useChatComposerStore = create<ChatComposerState>()((...args) => ({
  ...createChatComposerSlice()(...args),
}));

export const useComposerTokenMediaType = (): 'none' | 'image' | 'video' | 'mixed' => {
  return useChatComposerStore((state) => {
    const { composerTokenTypes } = state;
    const hasImage = composerTokenTypes.includes('image');
    const hasVideo = composerTokenTypes.includes('video');

    if (hasImage && hasVideo) {
      return 'mixed';
    }
    if (hasVideo) {
      return 'video';
    }
    if (hasImage) {
      return 'image';
    }

    return 'none';
  });
};
